import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
    selector: '[validateCcExpiry][formControlName],[validateCcExpiry][formControl],[validateCcExpiry][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => CcExpiryValidatorDirective),
            multi: true,
        },
    ],
})
export class CcExpiryValidatorDirective implements Validator
{
    public validate(control: AbstractControl): { [key: string]: any } {
        const regex = new RegExp('[\\d]{2}\\s?/\\s?[\\d]{2}');

        if (!regex.test(control.value)) {
            return {expiryInvalid: true};
        }

        return null;
    }
}
